import './style.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ConfirmComponent extends Component {
  static propTypes = {
    content: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.bool
    ]),
    confirmCallback: PropTypes.func,
    cancelCallback: PropTypes.func,
    disableConfirmBtn: PropTypes.bool,
  }

  render() {
    let { children, content, confirmText, cancelText, disableConfirmBtn } = this.props;

    return (
      <div className='zzcui-prompt-mask confirm' ref='prompt'>
        <div className='zzcui-prompt'>
          <div className='zzcui-prompt-content'>{content || children}</div>
          <div className='zzcui-prompt-btns'>
            {
              cancelText === false ? null :
                <div onClick={this.handleCancel}>{cancelText}</div>
            }
            {
              confirmText === false ? null :
                <div onClick={this.handleConfirm} className={disableConfirmBtn ? 'disable': 'normal'}>{confirmText}</div>
            }
          </div>
        </div>
      </div>
    );
  }

  componentDidUpdate() {
    this.refs.prompt.setAttribute('style', 'display: block');
  }

  handleConfirm = () => {
    let {disableConfirmBtn} = this.props;
    if(disableConfirmBtn){
      return;
    }
    this.props.confirmCallback();
    this.refs.prompt && this.refs.prompt.setAttribute('style', 'display: none');
  };

  handleCancel = () => {
    this.props.cancelCallback();
    this.refs.prompt && this.refs.prompt.setAttribute('style', 'display: none');
  };
}



// WEBPACK FOOTER //
// ./src/components/Confirm/ComfirComponent.js